module.exports = __webpack_public_path__ + "img/2019091802.d9657197.jpg";